import { create } from "zustand";

interface CookiePreferencesStore {
	/** True while someone has asked to review their choice (user menu). */
	reopened: boolean;
	openCookiePreferences: () => void;
	closeCookiePreferences: () => void;
}

/**
 * Lets the user menu reopen the consent card after a choice was made, so
 * withdrawing consent is as easy as giving it. Deliberately not persisted.
 */
export const useCookiePreferencesStore = create<CookiePreferencesStore>()(
	(set) => ({
		reopened: false,
		openCookiePreferences: () => set({ reopened: true }),
		closeCookiePreferences: () => set({ reopened: false }),
	})
);
